export const NOTIFICATION_BADGE_MAX = 99;

export function getNotificationBadgeCount(count: number): number {
  if (count <= 0) {
    return 0;
  }
  return Math.min(count, NOTIFICATION_BADGE_MAX);
}

export function formatNotificationBadge(count: number): string {
  return count > NOTIFICATION_BADGE_MAX
    ? `${NOTIFICATION_BADGE_MAX}+`
    : count.toString();
}
